import React from 'react';
import useThemeColors from '../../hooks/useThemeColors';

export const SkeletonMetricCard = () => {
  const { isDark } = useThemeColors();
  
  return (
    <div className="--theme-colors rounded-lg shadow-md p-4 sm:p-6 animate-pulse">
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className={`h-4 rounded w-20 mb-2 ${isDark ? 'bg-gray-700' : 'bg-gray-200'}`}></div>
          <div className={`h-6 sm:h-8 rounded w-24 ${isDark ? 'bg-gray-700' : 'bg-gray-200'}`}></div>
          <div className={`h-3 rounded w-16 mt-2 ${isDark ? 'bg-gray-700' : 'bg-gray-200'}`}></div>
        </div>
        <div className={`w-10 h-10 sm:w-12 sm:h-12 rounded-full ${isDark ? 'bg-gray-700' : 'bg-gray-200'}`}></div>
      </div>
    </div>
  );
};

export const SkeletonTable = () => {
  const { isDark } = useThemeColors();
  
  return (
    <div className="animate-pulse">
      <div className="space-y-3">
        {[1, 2, 3, 4].map((i) => (
          <div key={i} className="flex gap-2 sm:gap-4">
            <div className={`h-10 rounded flex-1 ${isDark ? 'bg-gray-700' : 'bg-gray-200'}`}></div>
            <div className={`h-10 rounded w-16 sm:w-20 ${isDark ? 'bg-gray-700' : 'bg-gray-200'}`}></div>
            <div className={`h-10 rounded w-16 sm:w-20 ${isDark ? 'bg-gray-700' : 'bg-gray-200'}`}></div>
            <div className={`h-10 rounded w-16 sm:w-20 ${isDark ? 'bg-gray-700' : 'bg-gray-200'}`}></div>
          </div>
        ))}
      </div>
    </div>
  );
};

export const SkeletonChart = () => {
  const { isDark } = useThemeColors();
  
  return (
    <div className={`h-64 rounded-lg animate-pulse flex items-center justify-center ${
      isDark ? 'bg-gray-800' : 'bg-gray-100'
    }`}>
      <div className={isDark ? 'text-gray-500' : 'text-gray-400'}>
        Loading chart data...
      </div>
    </div>
  );
};

export const SkeletonHashtagGrid = () => {
  const { isDark } = useThemeColors();
  
  return (
    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
      {[1, 2, 3, 4, 5, 6, 7, 8].map((i) => (
        <div key={i} className={`rounded-lg p-4 animate-pulse ${
          isDark ? 'bg-gray-800' : 'bg-gray-100'
        }`}>
          <div className={`h-6 rounded w-20 mx-auto mb-2 ${isDark ? 'bg-gray-700' : 'bg-gray-200'}`}></div>
          <div className={`h-4 rounded w-24 mx-auto ${isDark ? 'bg-gray-700' : 'bg-gray-200'}`}></div>
        </div>
      ))}
    </div>
  );
};

export const SkeletonDemographics = () => {
  const { isDark } = useThemeColors();
  
  return (
    <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
      <div className="space-y-3 animate-pulse">
        {[1, 2, 3, 4, 5].map((i) => (
          <div key={i} className="flex items-center gap-2">
            <div className={`h-4 rounded w-20 ${isDark ? 'bg-gray-700' : 'bg-gray-200'}`}></div>
            <div className={`h-2 rounded flex-1 ${isDark ? 'bg-gray-700' : 'bg-gray-200'}`}></div>
            <div className={`h-4 rounded w-12 ${isDark ? 'bg-gray-700' : 'bg-gray-200'}`}></div>
          </div>
        ))}
      </div>
    </div>
  );
};

